<template>
  <option-selector
    v-if="show"
    :title="'releases.new.title' | translate"
    :description="'releases.new.guide' | translate"
    :active="active"
    activeImage="UseNewChecked.svg"
    inactiveImage="UseNew.svg"
    @selected="onSelected"
  >
    <base-text-button
      v-if="active"
      :enabled="!isInteracted"
      @buttonClicked="startNewRelease"
    >
      {{'releases.keepgoing' | translate}}
    </base-text-button>
  </option-selector>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import OptionSelector from './OptionSelector.vue'

import { FeatureSwitches } from '../../../../../../../eco-domain-store-modules/src/userSettings/models'

import { ArchitectureType } from '@ecocoach/domain-store-modules/src/common'

const Wizard = namespace('wizard')
const App = namespace('app')
const ReleaseUi = namespace('releaseUi')
const UserSettings = namespace('userSettings')

@Component({
  components: {
    OptionSelector,
  },
})
export default class NewOptionClassic extends Vue {
  @App.Getter public userIdentifier: string
  @Wizard.Action public goToStep
  @Wizard.Getter public wizardSteps
  @Wizard.Mutation public closeReleaseDialog
  @ReleaseUi.Action public createRelease: (architectureType: ArchitectureType) => Promise<void>
  @ReleaseUi.Mutation public setInteracted
  @ReleaseUi.Getter public isInteracted
  @Prop() public active: boolean
  @UserSettings.Getter public isFeatureOn: (featureId: string) => boolean

  public get show() {
    return this.isFeatureOn(FeatureSwitches.plcConfigurationClassicArchitecture)
  }
  
  @Emit('selected')
  public onSelected() {
    return
  }

  public async startNewRelease() {
    await this.createRelease(ArchitectureType.Classic)
    this.closeReleaseDialog()
    const step = this.wizardSteps.find(s => s.name === 'defineRooms')
    this.goToStep({ step, router: this.$router })
  }
}
</script>
<style lang="scss" scoped>
.v-btn {
  border: solid 1px white;
}
</style>